import { create } from 'zustand'

const STORAGE_KEY = 'xenon-flex-ui-config'

function loadHiddenNavItems(): string[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    return stored ? JSON.parse(stored) : []
  } catch {
    return []
  }
}

function saveHiddenNavItems(items: string[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
  } catch {
    // ignore
  }
}

interface UIConfigState {
  hiddenNavItems: string[]
  setNavItemVisible: (href: string, visible: boolean) => void
}

export const useUIConfigStore = create<UIConfigState>((set, get) => ({
  hiddenNavItems: loadHiddenNavItems(),

  setNavItemVisible: (href: string, visible: boolean) => {
    const { hiddenNavItems } = get()
    const updated = visible
      ? hiddenNavItems.filter((h) => h !== href)
      : hiddenNavItems.includes(href)
        ? hiddenNavItems
        : [...hiddenNavItems, href]

    saveHiddenNavItems(updated)
    set({ hiddenNavItems: updated })
  },
}))
